import React from 'react';
import { 
	string, 
	func, 
} from 'prop-types';
import {getScore} from '../../../actions/score';
import {REQUESTING} from '../../../constants';
import algoliaSearchAdaptor from '../../../services/algoliaAdaptor';

class Container extends React.PureComponent {
	static propTypes = {
		render : func.isRequired,
		uid : string
	}

	constructor(props) {
		super(props);
		this.state = {
			recipeScores : [],
			showAllScores : false,
			requestStatus : REQUESTING.NONE,
			error : null
		};
	}
    
    componentDidMount = ()=>{
    	const {uid} = this.props;
    	getScore(uid, 
    		(scores)=>{
    			const recipeIds = Array.from(new Set(scores.map(score=>score.recipeId)));
    			algoliaSearchAdaptor.getObjects(recipeIds,(error,res)=>{
    				if(error){
    					this.setState({
    						requestStatus : REQUESTING.FAIL
    					});
    					return;
    				}
    				const recipes = res.results.filter(r=>Boolean(r));
    				const recipeScores = scores.filter(score=>{
    					return Boolean(recipes.find(r=>r.objectID===score.recipeId));
    				}).map(score=>{
    					const target = recipes.find(r=>r.objectID===score.recipeId);
    					const date = new Date(score.date);
    					return {
    						...score,
    						...target,
    						dateRaw : date,
    						date : date.toLocaleString()
    					};
    				}).sort((l,r)=>{
    					if(l.dateRaw && r.dateRaw){
    						return r.dateRaw - l.dateRaw;
    					}
    					return l.name-r.name;
    				});
    				this.setState({recipeScores,
    					requestStatus:REQUESTING.LOADED});
    			});
    		}, (error)=>{
    			this.setState({
    				requestStatus : REQUESTING.FAIL,
    				error
    			});
    		});
    	
    	this.setState({
    		requestStatus : REQUESTING.FETCHING
    	});
    }
	
    render(){
    	const {render,uid : _,...other} = this.props;
    	const {recipeScores, showAllScores} = this.state;
    	return render({
    		recipeScores : showAllScores ? recipeScores.slice(0,50) : recipeScores.slice(0,5),
    		showAllScores,
    		handleMoreScore : (more)=>()=>{
    			this.setState({
    				showAllScores : more
    			});
    		},
    		hasScore : recipeScores.length > 0
    	},
    	other);
    }
}

export default Container;
